import React, { useEffect, useState } from "react";
import "./DatabaseInsight.css";
import "../../Page.css";
import DatabaseHealth from "../../../Components/DatabaseInsightComponents/DatabaseHealth/DatabaseHealth";
import connectionsIcon from "../../../Assets/Images/connections.png";
import databaseIcon from "../../../Assets/Images/database.png";
import timeIcon from "../../../Assets/Images/time.png";
import restartIcon from "../../../Assets/Images/restart.png";
import { FaChartLine } from "react-icons/fa";
import heapIcon from "../../../Assets/Images/heap.png";
import cpuIcon from "../../../Assets/Images/cpu.png";
import totalRequestIcon from "../../../Assets/Images/requests.png";
import insertOptionIcon from "../../../Assets/Images/insertop.png";
import readLatencyIcon from "../../../Assets/Images/readlatency.png";
import writeLatency from "../../../Assets/Images/writelatency.png";
import nodeLogo from "../../../Assets/Images/node.png";
import redisLogo from "../../../Assets/Images/redis.png";
import mongodbLogo from "../../../Assets/Images/mongoDB.png";
import serverSize from "../../../Assets/Images/serversize.png";
import axios from "axios";
import { security_key, Url } from "../../../Services/Api";
import BottomToust from "../../../Components/BottomToust/BottomToust";
import { LuRefreshCcw } from "react-icons/lu";


const CacheRedisInsights = () => {
    const [cacheHealthData, setCacheHealthData] = useState();
    const [showMessage, setShowMessage] = useState(false);
    const [toastMessage, setToastMessage] = useState("");


    const [loading, setLoading] = useState(false);


    const clearCache = async () => {
        setLoading(true);
        setToastMessage('');
        setError('');

        try {
            const response = await axios.delete(`${Url}/api/redis-cache/clear`);
            setToastMessage(response.data.message || 'Redis Cache cleared successfully');
            fetchServerAndDatabaseData();
            setShowMessage(true);
        } catch (error) {
            setError(error.response?.data?.message || 'Failed to clear Redis cache');
            setShowMessage(true);
        } finally {
            setLoading(false);
            setShowMessage(true);
        }
    };


    const [error, setError] = useState(null);
    const [loadingData,setLoadingData] = useState(false);

     const fetchServerAndDatabaseData = async () => {
            const token = sessionStorage.getItem('authToken');
            const headers = {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
                'x-api-key': security_key
            };
            setError(null);
            const api = `/api/metrics`;
            try {
                setLoadingData(true)
                const response = await axios.get(
                    // Url + api
                    `${Url}/api/redis-stats`
                    , { headers: headers });
                console.log("database and server data", response);
                setCacheHealthData(response.data.data);
                setToastMessage("Redis Performance data have been fetched successfully!");
                setShowMessage(true);
                setLoadingData(false)
            } catch (error) {
                const errMsg = error?.response?.data?.message || error.message;
                setError(errMsg);
                setToastMessage(`Failed to fetch Database Perfromance data: ${errMsg}`);
                setShowMessage(true);
                setLoadingData(false)
            }

        };
    useEffect(() => {
       
        fetchServerAndDatabaseData();
    }, []);


    const serverDataObj = [
        {
            name: "CPU",
            icon: cpuIcon,
            value: cacheHealthData?.cpuUsage?.totalCPU?.value,
            unit: cacheHealthData?.cpuUsage?.totalCPU?.unit,
            status: cacheHealthData?.cpuUsage?.totalCPU?.status,
        },
    ];

    const handleCloseMessageModal = () => {
        setShowMessage(false);
    };

    useEffect(() => {
        if (showMessage === true) {
            const timeOut = setTimeout(() => {
                setShowMessage(false);
            }, 3000);

            return () => clearTimeout(timeOut);
        }
    }, [showMessage]);

    return (
        <div className="DashboardPage">
            <div className="database-and-server-insight-main-container">
                <DatabaseHealth
                    id={2}
                    title={"Redis"}
                    typeLogo={redisLogo}
                    timeCardTitle={"Up Time"}
                    time={cacheHealthData?.uptime}
                    cardData={[
                        {
                            title: "Memory Usage",
                            icon: serverSize,
                            valueOne: cacheHealthData?.memoryUsage?.current,
                            unit: "MB",
                            valueTwo: "infinity",
                            unitTwo: "MB",
                        },
                        {
                            title: "Hit Rate",
                            icon: heapIcon,
                            valueOne: cacheHealthData?.keyspace?.hitRate,
                            unit: "%",
                            valueTwo: "100",
                            unitTwo: "%",
                        },
                        {
                            title: "Total Hits",
                            icon: heapIcon,
                            valueOne: cacheHealthData?.keyspace?.hits,
                            unit: "hits",
                            valueTwo: parseInt(cacheHealthData?.keyspace?.misses)+parseInt(cacheHealthData?.keyspace?.hits),
                            unitTwo: "hits",
                        },
                        {
                            title: "Hits Missed",
                            icon: heapIcon,
                            valueOne: cacheHealthData?.keyspace?.misses,
                            unit: "hits",
                            valueTwo: parseInt(cacheHealthData?.keyspace?.misses)+parseInt(cacheHealthData?.keyspace?.hits),
                            unitTwo: "hits",
                        },



                        {
                            title: "Connected Clients",
                            icon: serverSize,
                            valueOne: cacheHealthData?.clients?.connectedClients,
                            unit: "Client",
                            valueTwo: "",
                            unitTwo: "",
                        },
                        // {
                        //     title: "Hit Rate",
                        //     icon: heapIcon,
                        //     valueOne: cacheHealthData?.keyspace?.hitRate,
                        //     unit: "%",
                        //     valueTwo: "100",
                        //     unitTwo: "%",
                        // },
                        // {
                        //     title: "Total Hits",
                        //     icon: heapIcon,
                        //     valueOne: cacheHealthData?.keyspace?.hits,
                        //     unit: "hits",
                        //     valueTwo: "100",
                        //     unitTwo: "%",
                        // },
                        // {
                        //     title: "Hits Missed",
                        //     icon: heapIcon,
                        //     valueOne: cacheHealthData?.keyspace?.misses,
                        //     unit: "hits",
                        //     valueTwo: "100",
                        //     unitTwo: "%",
                        // },


                    ]}
                    cardLength={1}
                    cardTitle={"Connection"}
                    cardIcon={connectionsIcon}
                    valueOne={20}
                    valueTwo={50}
                    serverData={serverDataObj}
                    userAndSystemData={cacheHealthData?.cpuUsage}
                    analyticTitle={"Total Order"}
                    analyticDuration={"Last 7 Days"}
                    analyticValue={236}
                    analyticGroth={20.23}
                    analyticIcon={<FaChartLine />}
                    analyticWidth={"100%"}
                    btnActive={true}
                    btnContent={"Clear Cache"}
                    onClick={() => {clearCache() }}
                    loading={loading}
                    refreshBtn={true}
                    refreshOnClick={()=>{fetchServerAndDatabaseData()}}
                    isRefreshLoading={loadingData}
                />
            </div>
            <BottomToust
                showMessage={showMessage}
                message={toastMessage}
                handleCloseMessageModal={() => handleCloseMessageModal()}
            />
        </div>
    );
};

export default CacheRedisInsights;